<template>
  <ion-card color="light">
    <ion-card-header>
      <ion-card-title class="ion-text-center">
        Need Sustanance Without Leaving Your Seat?
      </ion-card-title>
    </ion-card-header>

    <ion-card-content>
      <div class="ion-text-center">
        You better get our app! Never miss a bit of the action and get
        deliveries right to your seat.
      </div>
      <div class="ion-text-center ion-margin-top">
        <a
          v-if="canApple"
          href="https://stayseatedinc.net/ios"
          class="app-store-link"
        >
          <img src="./apple.svg" alt="Get on Apple App Store" />
        </a>
      </div>
      <div class="ion-text-center">
        <a href="https://stayseatedinc.net/android" class="play-store-link">
          <img src="./google.png" alt="Get on Google Play Store" />
        </a>
      </div>
    </ion-card-content>
  </ion-card>
</template>

<script>
import PlatformService from "@/services/Platform";

export default {
  computed: {
    canApple() {
      return !PlatformService.isAndroid();
    }
  }
};
</script>

<style lang="scss">
.app-store-holder {
  display: flex;
}
.app-store-link,
.play-store-link {
  display: inline-block;
  height: 40px;
  width: 134px;

  img {
    display: inline;
    width: auto;
    height: 100%;
  }
}
</style>
